// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

/**
 * Links to a record for pasting into other tools — a ticket, a chat, a spreadsheet — that
 * open it straight on this site (design doc §10.8).
 *
 * Absolute, from wherever the app is being served, so a link copied on staging opens
 * staging. Keyed by id rather than archive number or SN: an id never changes, so the link
 * keeps working whatever is later corrected on the record. Opening one needs a session
 * like any other page; without one, sign-in comes back to it (`return_to`).
 */

function absolute(path: string): string {
  return new URL(path, window.location.origin).href;
}

export function archiveLink(archiveId: string): string {
  return absolute(`/archives/${encodeURIComponent(archiveId)}`);
}

export function maintenanceEventLink(archiveId: string, eventId: string): string {
  return absolute(
    `/archives/${encodeURIComponent(archiveId)}/maintenance/${encodeURIComponent(eventId)}`,
  );
}
